export default [
  {
    name: 'GetContinentList',
    method: 'post',
    desc: '洲区列表获取',
    path: '/obt/qz/staticData/getContinentList',
    params: {}
  },
  {
    name: 'GetConsularList',
    method: 'post',
    desc: '领区列表',
    path: '/obt/qz/staticData/getConsularList',
    params: {
      isShow: '0'
    }
  },
  {
    name: 'GetCountryList',
    method: 'post',
    desc: '签证基础数据--国家列表',
    path: '/obt/qz/staticData/getCountryList',
    params: {}
  },
  {
    name: 'VisaList',
    method: 'post',
    desc: '签证产品列表',
    path: '/obt/qz/shopping/visaList',
    params: {
      continentId: '', // 本地洲区id
      countryId: '', // 国家id
      visaType: '', // 签证类型id（选填） 1.旅游签证 2.商务签证 3.探亲访友签证 4.留学签证 5.夏令营签证
      consularDistrictName: '', // 所属领区 北京、上海、广州 ,
      isSpeed: '', // 是否快速签证:0.否 1.是
      tripType: '', // 1因公2因私
      pageNum: 1,
      count: 999
    }
  },
  {
    name: 'VisaDetail',
    method: 'post',
    desc: '查询签证产品详情',
    path: '/obt/qz/shopping/visaDetail',
    params: {
      detailType: '2', // 1热门签证产品列表 2签证产品列表 默认2
      visaId: '', // 签证信息id，此id唯一
      tripType: '', // 1因公2因私
    }
  },
  {
    name: 'VisaAssociation',
    method: 'post',
    desc: '注意事项、签证咨询、案例分析、资料下载的相关信息',
    path: '/obt/qz/shopping/visaAssociation',
    params: {
      associationType: '', // 签证相关信息类型 1Matters:注意事项 | 2VisaConsult:签证资讯 | 3CaseAnalysis:案例分析 | 4MaterialDownload:资料下载 
      countryId: '', // 签证信息id，此id唯一
      pageNum: 1,
      count: 999
    }
  },
  {
    name: 'VisaAssociationDetail',
    method: 'post',
    desc: '查询签证产品详情',
    path: '/obt/qz/shopping/visaAssociationDetail',
    params: {
      associationId: '', // 签证相关信息id
    }
  },
  {
    name: 'NewAppointment',
    method: 'post',
    desc: '签证预约动态信息查询',
    path: '/obt/qz/shopping/newAppointment',
    params: {
      consularDistId: '', // 所属领区Id
      count: null
    }
  },
  {
    name: 'visaBook',
    method: 'post',
    desc: '签证订单下单',
    path: '/obt/qz/order/book',
    params: {
      'orderFrom': '',
      'tripDate': '',
      'addressee': '',
      'addresseePhone': '',
      'addresseeSite': '',
      'expressCompany': '',
      'expressCompanyName': '',
      'kdPayMethod': '',
      'otherRemark': '',
      'tripType': '',
      'ccsqdId': '',
      'ccsqdNo': '',
      'ccsqdRemark': '',
      'projectId': '',
      'projectName': '',
      'projectCode': '',
      'linkTel': '',
      'linkman': '',
      'linkEmail': '',
      'costCenterId': '',
      'costCenterName': '',
      'costCenterCode': '',
      'subjectCode': '',
      'routeId': '',
      'ifSameOrder': '',
      'sendMethod': '',
      'psbz': '',
      'recipient': '',
      'reciPhone': '',
      'reciEmail': '',
      'reciAddr': '',
      'postCode': '',
      'postOrderId': '',
      'postMothed': '',
      'psyqsj': '',
      'peopleInfos': [
        {
          'empId': '',
          'passengerName': '',
          'passengerPhone': '',
          'passengerType': '',
          'idNo': '',
          'sex': '',
          'age': '',
          'inputNo': ''
        }
      ]
    }
  },
]
